export const RESET_ON_BOARDING_MUTATION = 'resetOnBoardingAction';
export const SET_ON_BOARDING_MUTATION = 'setOnBoardingMutation';
